import { Modal, type ModalFuncProps } from 'antd'
import type { ButtonProps } from 'antd'

export const confirm = (options: ModalFuncProps): Promise<boolean> => {
  return new Promise((resolve) => {
    Modal.confirm({
      ...options,

      okText: options.okText || 'Закрыть',
      okButtonProps: {
        type: 'default',
      } as ButtonProps,

      cancelText: options.cancelText || 'Отмена',
      cancelButtonProps: {
        variant: 'solid',
        color: 'purple',
      } as ButtonProps,

      centered: true,

      onOk: () => resolve(true),
      onCancel: () => resolve(false),
    })
  })
}
